/**
* This file is loaded asyncronously in the footer.
* All custom global scripts should be included here.
*/

	/*
	A little info for this js file:

	As much as possible, this file should be kept organized. Currently, two major divisions are seen below, delinitated by their respective functions of "on load" and "ready".
		As mentioned below, most code added to this file should be included within the "on load" function.

	For ease of future use, include any new code at the bottom of the relevant section of the page, adding clear comments to explain the purpose of the code being written,
		including any relavant details regarding what the code overrides, etc.
	*/


(function(){
	'use strict';

	// rerun lazyload on screen size updates
	window.addEventListener( 'resize', function() {
		dbs.lazyload();
	});

	// Load event function ... most custom stuff goes here. Safer for async.
	window.addEventListener( 'load', function() {
		/* Search Form functionality
		 * The click functionality involves three different actions,
		 * depending on conditions the various clicks provide.
		 */
		var searchOpen = document.querySelectorAll( '.search-form__button--open' );
		var searchClose = document.querySelectorAll( '.search-form__button--close' );

		if ( searchOpen ) {
			for (var i=0; searchOpen.length > i; i++) {
				searchOpen[i].addEventListener( 'click', function() {
					this.parentElement.classList.add( 'search-form--active' );
					this.parentElement.querySelector('.site_search__field').focus();
		
					// Hide the search bar after click out of it
					document.getElementById( 'content' ).addEventListener( 'click', function() {
						if ( this.parentElement.classList.contains( 'search-form--active' ) ) {
							this.parentElement.classList.remove( 'search-form--active' );
						}
					});
				});
			}
			
			for (var i=0; searchClose.length > i; i++) {
				searchClose[i].addEventListener( 'click', function() {
					this.parentElement.classList.remove( 'search-form--active' );
				});
			}
		}


		/**
		 * Linkclicker
		 * 
		 * A class placed on a wrapping element with a link inside to make the wrapper clickable.
		 * Note: the container should have only one link.
		 */
		var linkclickers = document.querySelectorAll('.linkclicker');

		for ( var i = 0; linkclickers.length > i; i++ ) {
			var linkclicker = linkclickers[i];

			linkclicker.addEventListener('click', function(e) {
				e.preventDefault();
				var link = this.querySelector('a');
				var linkPath = link.getAttribute('href');
				
				if ( link.getAttribute('target', "_blank") ) {
					window.open(linkPath);
				} else {
					window.location.href = linkPath;
				}
			});
		}
 
        // Get WPML current language
        function getCookie(c_name) {
            var c_value = document.cookie,
                c_start = c_value.indexOf(" " + c_name + "=");
            if (c_start == -1) c_start = c_value.indexOf(c_name + "=");
            if (c_start == -1) {
                c_value = null;
            } else {
                c_start = c_value.indexOf("=", c_start) + 1;
                var c_end = c_value.indexOf(";", c_start);
                if (c_end == -1) {
                    c_end = c_value.length;
                }
                c_value = unescape(c_value.substring(c_start, c_end));
            }
            return c_value;
        }

		/**
		 * Force external links/PDFs to open in a new tab.
		 * From https://stackoverflow.com/questions/2910946/test-if-links-are-external-with-jquery-javascript
		 * 2019-07-11 - TA
		 */
		function link_is_external(link_element) {
			return ( link_element.host !== window.location.host || link_element.href.indexOf("pdf") > -1 );
		}

		var anchorElements = document.getElementsByTagName('a');
		for ( let anchorElement of anchorElements ) {

			if ( link_is_external( anchorElement ) ) {
				anchorElement.setAttribute( 'target','_blank' );
				anchorElement.setAttribute( 'rel','noopener' );

				// Add assistive text to alert of external links
                if ( getCookie('wp-wpml_current_language') == 'en' ) {
                    var assistiveText = '<span class="assistive">. External Link. Opens in new window.</span>';
                } else if ( getCookie('wp-wpml_current_language') == 'fr' ) {
                    var assistiveText = '<span class="assistive">. Lien externe. S\'ouvre dans une nouvelle fenêtre.</span>';
                }
				var assistiveTextContainer = document.createElement( 'span' );
				assistiveTextContainer.innerHTML = assistiveText;
				anchorElement.appendChild( assistiveTextContainer.firstChild );
			}
		}

		/**
		 * Detects if element is in viewport
		 * 
		 * @usage
		 * var el = document.querySelector('.element-class');
		 *
		 * window.addEventListener('scroll', function(event) {
		 * 		if (isInViewport(el)) {
		 *			el.classList.add("in-view");
		 *		}
		 * }, false);
		 * 
		 * NOTE: If the whole layout is taller than the viewport, this will never fire. It is often
		 * better to target one small element inside a layout.
		 */
		function isInViewport(elem) {
			var distance = elem.getBoundingClientRect();
			return (
				distance.top >= 0 &&
				distance.left >= 0 &&
				distance.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
				distance.right <= (window.innerWidth || document.documentElement.clientWidth)
			);
		};

		// Find all animated elements and check if they're in view on load, and on scroll
		var els = document.querySelectorAll('.animated');
		
		for (let i = 0; els.length > i; i++) {
			let _this = els[i];

			// Check on load
			if ( isInViewport(_this) ) {
				_this.classList.add("in-view");
			}

			// Check on scroll
			window.addEventListener('scroll', function(event) {
				if ( isInViewport(_this) ) {
					_this.classList.add("in-view");
				}
			}, false);
		}

		/**
		 * Collapsible JS.
		 * 
		 * Note: This cannot go in the collapsible template in case there are multiple
		 * collapsibles on the page.
		 */
		var collapsibleHeaders = document.querySelectorAll('.collapsible-row__header');

		if ( collapsibleHeaders ) {
			for ( var i = 0; collapsibleHeaders.length > i; i++ ) {
				var collapsibleHeader = collapsibleHeaders[i];

				collapsibleHeader.addEventListener('click', function() {
					this.classList.toggle('active');
					var textHeight = this.nextElementSibling.querySelector('.collapsible-text').clientHeight; // Get height of text within collapsible row
					var rowHeight = this.nextElementSibling.clientHeight; // Get height of row to see if it's expanded

					if ( rowHeight == 0 ) { // If collapsible content is collapsed...
						this.nextElementSibling.style.height = textHeight + 1 + "px";
					} else {
						this.nextElementSibling.style.height = 0 + "px";
					}

					if ( this.parentNode.classList.contains('expanded') ) {
						this.setAttribute('aria-expanded', 'true');
					} else {
						this.setAttribute('aria-expanded', 'false');
					}
				});
			}
		}

        /**
         * If a submenu expands past the right side of the viewport, this
         * moves it left until it is all the way inside the viewport.
         */
        var mainMenuToplevelItems = document.querySelectorAll('.main-menu .menu__item.toplevel');
        for (var i = 0; i < mainMenuToplevelItems.length; i++) {
            mainMenuToplevelItems[i].addEventListener('mouseenter', function() {
                var submenu = this.querySelector('.menu__submenu');
                if (submenu !== null) {
                    var bounding = submenu.getBoundingClientRect();
                    if (bounding.right > (window.innerWidth || document.documentElement.clientWidth)) {
                        var diff;
                        if (window.innerWidth < document.documentElement.clientWidth) {
                            diff = bounding.right - window.innerWidth;
                        } else {
                            diff = bounding.right - document.documentElement.clientWidth;
                        }
                        var submenuStyle = window.getComputedStyle(submenu);
                        var rightValue = submenuStyle.getPropertyValue('left').replace('px', '');
                        submenu.style.left = (Number(rightValue) - diff) + 'px';
                    }
                }
                
                var submenuItems = submenu.querySelectorAll('.menu__item--l1');
                for (var j = 0; j < submenuItems.length; j++) {
                    submenuItems[j].addEventListener('mouseenter', function() {
                        var subSubmenu = this.querySelector('.menu__submenu--l2');
                        if (subSubmenu !== null) {
                            var bounding = subSubmenu.getBoundingClientRect();
                            if (bounding.right > (window.innerWidth || document.documentElement.clientWidth)) {
                                var diff;
                                if (window.innerWidth < document.documentElement.clientWidth) {
                                    diff = bounding.right - window.innerWidth;
                                } else {
                                    diff = bounding.right - document.documentElement.clientWidth;
                                }
                                var subSubmenuStyle = window.getComputedStyle(subSubmenu);
                                var rightValue = subSubmenuStyle.getPropertyValue('left').replace('px', '');
                                subSubmenu.style.left = (Number(rightValue) - diff) + 'px';
                            }
                        }
                    });
                }
            });
        }
        
        /**
         * Check WPML current language by cookie and translate 'Home' in breadcrumbs.
         */
        function getCookie(cname) {
            let name = cname + "=";
            let decodedCookie = decodeURIComponent(document.cookie);
            let ca = decodedCookie.split(';');
            for(let i = 0; i <ca.length; i++) {
                let c = ca[i];
                while (c.charAt(0) == ' ') {
                    c = c.substring(1);
                }
                if (c.indexOf(name) == 0) {
                    return c.substring(name.length, c.length);
                }
            }
            return "";
        }
        if (getCookie('wp-wpml_current_language') == 'fr') document.querySelector('.page-header .breadcrumbs a').textContent = 'Accueil';
	}); // End of load function
	

	// Include ready events here
	window.addEventListener( 'DOMContentLoaded', function() {
		
	});


	/**
	 * Cookie Popup scripts
	 */
	var popUp		= document.getElementById('cookie-popup');
	var popUpMain	= document.getElementById('popup-main');

	// Hide popup and background filter and set cookie
	function accept() {
		popUp.style.display = "none";
		document.body.classList.add('cookies');
		setCookie( "accepts-cookie", "accepts-cookie-set", 365 );
	}

	document.getElementById('accept-button').addEventListener( 'click', function() {
		accept();
	});

	var cookie = readCookie( 'accepts-cookie' );
	// If user already has accepted cookies, don't show popup
	if ( cookie == 'accepts-cookie-set' ) {
		popUp.style.display = "none";
	} else {
		// Force screen reader to read popup
		popUpMain.setAttribute("aria-live", "assertive");
	}
})();
